module.exports = __webpack_public_path__ + "static/media/hisar.57ed0039.png";